import CitiesAPI  from "@/services/api/api-cities"
import CityDTO from "@/DTO/CityDTO"
export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  getters: {
    items: state => state.items
  },

  mutations: {
    set(state, items) {
      state.items = items
    }
  },

  actions: {
    async list({state, commit}) {
      try {
        if(state.items) return
        let res = await CitiesAPI.list()
        res = res.map(city => new CityDTO(city))
        console.log(res)
        commit('set', res)
        return res
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
  }
}